import { AxiosResponse } from 'axios';

import { Admin } from '@/types/admin';
import { Session } from '@/types/session';
import { api } from '@/services/api/axios/instance';

type ActivateParams = {
  data: {
    admin: Admin;
    password: string;
    token: string;
  };
};

type ResetPasswordParams = {
  data: {
    adminId: string;
    password: string;
    token: string;
  };
};

type UpdatePasswordParams = {
  data: {
    adminId: Admin['id'];
    currentPassword: string;
    newPassword: string;
  };
};

export const adminsApi = {
  activate: async (config: ActivateParams): Promise<void> => {
    const { password, token, admin } = config.data;
    const path = `admins/${admin.id}`;
    const params = {
      first_name: admin.firstName,
      last_name: admin.lastName,
      kana_first_name: admin.kanaFirstName,
      kana_last_name: admin.kanaLastName,
      password: password.trim(),
    };

    await api.put(path, params, {
      headers: {
        'x-v2-admin-activate-token': `Bearer ${token}`,
      },
    });
  },
  resetPassword: async (config: ResetPasswordParams): Promise<void> => {
    const { password, token, adminId } = config.data;
    const path = `admins/${adminId}/password`;
    const params = {
      new: password.trim(),
    };

    await api.post(path, params, {
      headers: {
        'x-v2-admin-reset-password-token': `Bearer ${token}`,
      },
    });
  },
  updatePassword: async (config: UpdatePasswordParams): Promise<Session> => {
    const { currentPassword, newPassword, adminId } = config.data;
    const path = `admins/${adminId}/password`;
    const params = {
      current: currentPassword.trim(),
      new: newPassword.trim(),
    };

    const response: AxiosResponse<{
      session: Session;
    }> = await api.put(path, params);

    return response.data.session;
  },
};
